import { KeyValue } from "@/main/models/common";
import { IInitialReducerData } from "@/main/services/reducerUtils";

export enum ReportTemplateTypeTypes {
	GET_REPORT_TEMPLATE_TYPE = "@reportTemplateType/GET_REPORT_TEMPLATE_TYPE",
	SAVE_REPORT_TEMPLATE_TYPE = "@reportTemplateType/SAVE_REPORT_TEMPLATE_TYPE",
	RESET_REDUCER_REPORT_TEMPLATE_TYPE = "@reportTemplateType/RESET_REDUCER_REPORT_TEMPLATE_TYPE",
}

export interface ReportTemplateTypeState {
	readonly reportTemplateType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: IInitialReducerData;
	};
}

export interface GetReportTemplateType {
	type: typeof ReportTemplateTypeTypes.GET_REPORT_TEMPLATE_TYPE;
	payload: {
		keyReducer: string;
	};
}

export interface SaveReportTemplateType {
	type: typeof ReportTemplateTypeTypes.SAVE_REPORT_TEMPLATE_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerReportTemplateType {
	type: typeof ReportTemplateTypeTypes.RESET_REDUCER_REPORT_TEMPLATE_TYPE;
}

export type ReportTemplateTypeActionTypes =
	| GetReportTemplateType
	| SaveReportTemplateType
	| ResetReducerReportTemplateType;
